import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import './Custom-Popup.scss';
import { Button } from '@material-ui/core';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const CustomPopupModel = (props) => {
  const {
    popUp,
    onClick,
    onClickSwap,
    showImage,
    onClickCancel,
    modalPostion,
    style,
    NoCancelButtonNeeded,
    disableBackdropClick,
    disableEscapeKeyDown,
  } = props;
  const classes = useStyles();
  const [modalStyle] = useState(() => (modalPostion ? modalPostion() : getModalStyle()));

  const handleClose = (event, reason) => {
    if ((disableBackdropClick && reason === 'backdropClick') || (disableEscapeKeyDown && reason === 'escapeKeyDown')) {
      return;
    }
    document.body.classList.remove('popup-active');
    onClickCancel();
  };

  const onOKClick = () => {
    document.body.classList.remove('popup-active');
    onClick();
  };

  const onSwapClick = () => {
    document.body.classList.remove('popup-active');
    onClickSwap();
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='delete-popup'>
        {showImage && (
          <div className='row d-flex justify-content-center my-3'>
            <img alt={popUp?.index} src={popUp?.image} className='img' />
          </div>
        )}
        <div className='delete-popup-title'>
          {popUp?.title} <br />
          {popUp?.name ? `${popUp?.name} ?` : null}
        </div>
        <p className='delete-popup-description'>{popUp?.description}</p>
        <div
          className={
            !popUp?.swapBtn
              ? 'col-md-10 offset-1 d-flex justify-content-around px-4 mt-4'
              : 'col-md-12 d-flex justify-content-around mt-4'
          }
        >
          {!NoCancelButtonNeeded && (
            <Button
              variant='outlined'
              size={!popUp?.swapBtn ? 'large' : 'small'}
              color='secondary'
              onClick={(e) => handleClose()}
              style={style ?? {}}
            >
              {popUp?.cancel || 'Cancel'}
            </Button>
          )}
          {popUp?.swapBtn && (
            <Button
              variant='contained'
              size={!popUp?.swapBtn ? 'large' : 'small'}
              color='primary'
              onClick={(e) => onSwapClick()}
              style={style ?? {}}
            >
              {popUp?.swapBtn}
            </Button>
          )}
          {popUp?.buttonName && (
            <Button
              variant='contained'
              size={!popUp?.swapBtn ? 'large' : 'small'}
              color='primary'
              onClick={(e) => onOKClick()}
              style={style ?? {}}
            >
              {popUp?.buttonName}
            </Button>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal open={popUp.status} onClose={handleClose}>
        {body}
      </Modal>
    </div>
  );
};

export default CustomPopupModel;
